import * as React from "react";
import Dropdown from "../../../../../components/general/Dropdown.tsx";

export type CashFlowDirection = 'all' | 'inflow' | 'outflow';

interface BusinessCardFilterProps {
    selectedFilter: CashFlowDirection;
    onFilterChange: (filter: CashFlowDirection) => void;
}

export function BusinessCardFilter({
                                       selectedFilter,
                                       onFilterChange,
                                   }: BusinessCardFilterProps) {
    const filterOptions = [
        { value: 'all' as CashFlowDirection, label: 'Alle' },
        { value: 'outflow' as CashFlowDirection, label: 'Inkoop' },
        { value: 'inflow' as CashFlowDirection, label: 'Verkoop' },
    ];

    const selectedOption = filterOptions.find(opt => opt.value === selectedFilter) || filterOptions[0];

    return (
        <div className="w-48">
            <Dropdown
                selected={{ value: selectedOption.value, label: selectedOption.label }}
                options={filterOptions}
                onUpdateFunc={(value) => onFilterChange(value as CashFlowDirection)}
            />
        </div>
    );
}